import { create } from 'zustand';
import type { Automation } from '../types/automation.types';

interface AutomationsStore {
    // Unsaved automation state (for new automations being created)
    unsavedAutomation: Automation | null;

    // Actions
    setUnsavedAutomation: (automation: Automation | null) => void;
    clearUnsavedAutomation: () => void;
}

export const useAutomationsStore = create<AutomationsStore>(set => ({
    unsavedAutomation: null,
    setUnsavedAutomation: automation => set({ unsavedAutomation: automation }),
    clearUnsavedAutomation: () => set({ unsavedAutomation: null }),
}));
